(function () {
  if (window.__flashSaleCountdownInit) return;
  window.__flashSaleCountdownInit = true;

  function pad(value) {
    return value < 10 ? '0' + value : String(value);
  }

  function init(countdown) {
    if (countdown.getAttribute('data-flash-countdown-ready') === 'true') return;

    var targetAt = parseInt(countdown.getAttribute('data-flash-countdown-at'), 10) * 1000;
    var fields = [
      countdown.querySelector('[data-flash-days]'),
      countdown.querySelector('[data-flash-hours]'),
      countdown.querySelector('[data-flash-minutes]'),
      countdown.querySelector('[data-flash-seconds]')
    ];
    if (!targetAt || fields.indexOf(null) !== -1) return;

    countdown.setAttribute('data-flash-countdown-ready', 'true');

    var previous = [];
    var timerId = 0;

    function stop() {
      if (!timerId) return;
      clearInterval(timerId);
      timerId = 0;
    }

    function tick() {
      if (!countdown.isConnected) {
        stop();
        return false;
      }

      var left = Math.max(0, Math.floor((targetAt - Date.now()) / 1000));
      var values = [
        Math.floor(left / 86400),
        Math.floor((left % 86400) / 3600),
        Math.floor((left % 3600) / 60),
        left % 60
      ];

      values.forEach(function (value, index) {
        if (previous[index] === value) return;
        fields[index].textContent = pad(value);
        previous[index] = value;
      });

      if (left > 0) return true;

      stop();
      if (countdown.getAttribute('data-flash-countdown-expiry') === 'remove') {
        countdown.remove();
      }
      return false;
    }

    if (tick()) timerId = setInterval(tick, 1000);
  }

  function initAll(root) {
    if (root.matches && root.matches('[data-flash-countdown]')) init(root);
    Array.prototype.forEach.call(root.querySelectorAll('[data-flash-countdown]'), init);
  }

  initAll(document);

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
